
export default function GoogleButton() {
    return (
        <div id="googleLoginButton">
            <img id="googleImage" src="/images/googleLogo.png" loading="lazy"/>
            Sign In With Google
        </div>
    )
}